import React, { useState } from 'react'
import { Fragment } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { INavigationMenu } from 'components/Layout/Header/Navigation'
import MobileMenuItem from 'components/Layout/Header/Navigation/MobileMenuItem'

interface Props {
	navItems: INavigationMenu[]
}

export default function MobileNavigationMenu({ navItems }: Props) {
	const [open, setOpen] = useState(false)
	return (
		<>
			<button onClick={() => setOpen(!open)} aria-label="Open menu" className="flex xl:hidden">
				<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-8 w-8 text-white">
					<path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
				</svg>
			</button>

			<Transition.Root show={open} as={Fragment}>
				<Dialog as="div" className="fixed inset-0 z-30 overflow-hidden" onClose={setOpen}>
					<div className="absolute inset-0 overflow-hidden">
						<Transition.Child
							as={Fragment}
							enter="ease-in-out duration-500"
							enterFrom="opacity-0"
							enterTo="opacity-100"
							leave="ease-in-out duration-500"
							leaveFrom="opacity-100"
							leaveTo="opacity-0"
						>
							<Dialog.Overlay className="absolute inset-0 bg-black bg-opacity-75 transition-opacity" />
						</Transition.Child>
						<div className="fixed inset-y-0 right-0 flex max-w-full">
							<Transition.Child
								as={Fragment}
								enter="transform transition ease-in-out duration-500 sm:duration-700"
								enterFrom="translate-x-full"
								enterTo="translate-x-0"
								leave="transform transition ease-in-out duration-500 sm:duration-700"
								leaveFrom="translate-x-0"
								leaveTo="translate-x-full"
							>
								<div className="relative w-screen max-w-[100vw] lg:max-w-[75vw] 2xl:max-w-[50vw]">
									<Transition.Child
										as={Fragment}
										enter="ease-in-out duration-500"
										enterFrom="opacity-0"
										enterTo="opacity-100"
										leave="ease-in-out duration-500"
										leaveFrom="opacity-100"
										leaveTo="opacity-0"
									>
										<div className="absolute top-0 left-0 z-20 flex p-4 sm:pr-4">
											<button type="button" aria-label="Close menu" className="rounded-full bg-white p-1 shadow" onClick={() => setOpen(false)}>
												<span className="sr-only">Close menu</span>
												<svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-slate-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
													<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
												</svg>
											</button>
										</div>
									</Transition.Child>
									<div className="z-10 flex h-full flex-col overflow-y-scroll">
										<div className="relative flex-1">
											{/* Content */}
											<div className="flex flex-col">
												{navItems.map((menu) => {
													return <MobileMenuItem key={menu.name} menu={menu} />
												})}
											</div>
											{/* /End Content */}
										</div>
									</div>
								</div>
							</Transition.Child>
						</div>
					</div>
				</Dialog>
			</Transition.Root>
		</>
	)
}
